import { render } from "./app-icon-empty-placeholder.vue?vue&type=template&id=3cb123c2"
const script = {}

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/icon/app-icon-empty-placeholder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3cb123c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3cb123c2', __exports__)) {
    console.log('reload')
    api.reload('3cb123c2', __exports__)
  }
  
  module.hot.accept("./app-icon-empty-placeholder.vue?vue&type=template&id=3cb123c2", () => {
    console.log('re-render')
    api.rerender('3cb123c2', render)
  })

}


export default __exports__